import { QUERY_DEFAULTS } from '@/shared/lib/constants';
import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { getConnectorApi } from '@/entities/connector/api';
import type { Connector } from '@/entities/connector/types';

type UseConnectorParams = {
  id: string;
  enabled?: boolean;
};

export const useConnector = ({ id, enabled = true }: UseConnectorParams) => {
  return useQueryWithBoundary<Connector>({
    ...DEFAULT_QUERY_OPTIONS,
    queryKey: connectorKeys.detail(id),
    queryFn: () => getConnectorApi(id),
    enabled: enabled && !!id,
    staleTime: QUERY_DEFAULTS.STALE_TIME.MEDIUM,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
  });
};
